import { gql } from '@apollo/client'

export default gql`
  mutation course_projects_delete($id: ID!) {
    courseProjectDelete(id: $id) {
      id
    }
  }
`
